{
  "SLA": {
    "HEADER": "Dohody o úrovni služieb",
    "ADD_ACTION": "Pridať SLA",
    "ADD_ACTION_LONG": "Vytvoriť novú SLA politiku",
    "DESCRIPTION": "Dohody o úrovni služieb (SLA) sú zmluvy, ktoré definujú jasné očakávania medzi vaším tímom a zákazníkmi. Stanovujú štandardy pre doby odpovede a vyriešenia, vytvárajú rámec pre zodpovednosť a zabezpečujú konzistentnú, kvalitnú skúsenosť.",
    "LEARN_MORE": "Zistiť viac o SLA",
    "LOADING": "Načítavajú sa SLA",
    "PAYWALL": {
      "TITLE": "Aktualizujte na vytváranie SLA",
      "AVAILABLE_ON": "Funkcia SLA je dostupná iba v plánoch Business a Enterprise.",
      "UPGRADE_PROMPT": "Aktualizujte svoj plán pre prístup k pokročilým funkciám ako správa tímov, automatizácie, vlastné atribúty a ďalšie.",
      "UPGRADE_NOW": "Aktualizovať teraz",
      "CANCEL_ANYTIME": "Svoj plán môžete kedykoľvek zmeniť alebo zrušiť"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Funkcia SLA je dostupná iba v platených plánoch.",
      "UPGRADE_PROMPT": "Aktualizujte na platený plán pre prístup k pokročilým funkciám ako protokoly auditu, kapacita agentov a ďalšie.",
      "ASK_ADMIN": "Ohľadom aktualizácie sa obráťte na svojho administrátora."
    },
    "LIST": {
      "404": "V tomto účte nie sú dostupné žiadne SLA.",
      "EMPTY": {
        "TITLE_1": "Enterprise P0",
        "DESC_1": "Problémy nahlásené enterprise zákazníkmi, ktoré vyžadujú okamžitú pozornosť.",
        "TITLE_2": "Enterprise P1",
        "DESC_2": "Problémy nahlásené enterprise zákazníkmi, ktoré je potrebné rýchlo potvrdiť."
      },
      "BUSINESS_HOURS_ON": "Pracovný čas zapnutý",
      "BUSINESS_HOURS_OFF": "Pracovný čas vypnutý",
      "RESPONSE_TYPES": {
        "FRT": "Hranica času prvej odpovede",
        "NRT": "Hranica času ďalšej odpovede",
        "RT": "Hranica času vyriešenia",
        "SHORT_HAND": {
          "FRT": "FRT",
          "NRT": "NRT",
          "RT": "RT"
        }
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Názov SLA",
        "PLACEHOLDER": "Názov SLA",
        "REQUIRED_ERROR": "Názov SLA je povinný",
        "MINIMUM_LENGTH_ERROR": "Minimálna dĺžka je 2 znaky",
        "VALID_ERROR": "Povolené sú iba písmená, čísla, pomlčka a podčiarkovník"
      },
      "DESCRIPTION": {
        "LABEL": "Popis",
        "PLACEHOLDER": "SLA pre prémiových zákazníkov"
      },
      "FIRST_RESPONSE_TIME": {
        "LABEL": "Čas prvej odpovede",
        "PLACEHOLDER": "5"
      },
      "NEXT_RESPONSE_TIME": {
        "LABEL": "Čas ďalšej odpovede",
        "PLACEHOLDER": "5"
      },
      "RESOLUTION_TIME": {
        "LABEL": "Čas do riešenia",
        "PLACEHOLDER": "60"
      },
      "BUSINESS_HOURS": {
        "LABEL": "Otváracie hodiny",
        "PLACEHOLDER": "Iba počas pracovných hodín"
      },
      "THRESHOLD_TIME": {
        "INVALID_FORMAT_ERROR": "Hranica musí byť číslo väčšie ako nula"
      },
      "EDIT": "Upraviť",
      "CREATE": "Vytvoriť",
      "DELETE": "Vymazať",
      "CANCEL": "Zrušiť"
    },
    "ADD": {
      "TITLE": "Pridať SLA",
      "DESC": "Priateľské sľuby pre skvelé služby!",
      "API": {
        "SUCCESS_MESSAGE": "SLA bola úspešne pridaná",
        "ERROR_MESSAGE": "Vyskytla sa chyba, skúste to prosím znova"
      }
    },
    "DELETE": {
      "TITLE": "Odstrániť SLA",
      "API": {
        "SUCCESS_MESSAGE": "SLA bola úspešne odstránená",
        "ERROR_MESSAGE": "Vyskytla sa chyba, skúste to prosím znova"
      },
      "CONFIRM": {
        "TITLE": "Potvrdiť vymazanie",
        "MESSAGE": "Naozaj chcete odstrániť ",
        "YES": "Áno, vymazať ",
        "NO": "Nie, ponechať "
      }
    },
    "EVENTS": {
      "TITLE": "Porušenia SLA",
      "FRT": "Čas do prvej reakcie",
      "NRT": "Čas ďalšej odpovede",
      "RT": "Čas vyriešenia",
      "SHOW_MORE": "{count} ďalších",
      "HIDE": "Skryť {count} riadkov"
    }
  }
}
